export default __webpack_public_path__ + "static/media/mix3infibre.86f0a97c.jpg";